/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskApprovalsGet } from "../funcs/riskApprovalsGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RiskPolicyApproval } from "../models/components/riskpolicyapproval.js";
import {
  GetRiskPolicyApprovalRequest,
  GetRiskPolicyApprovalSecurity,
} from "../models/operations/getriskpolicyapproval.js";
import { unwrapAsync } from "../types/fp.js";
export type RiskGetApprovalQueryData = RiskPolicyApproval;

export function prefetchRiskGetApproval(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetRiskPolicyApprovalRequest,
  security?: GetRiskPolicyApprovalSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRiskGetApprovalQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRiskGetApprovalQuery(
  client$: GramCore,
  request: GetRiskPolicyApprovalRequest,
  security?: GetRiskPolicyApprovalSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<RiskGetApprovalQueryData>;
} {
  return {
    queryKey: queryKeyRiskGetApproval({
      id: request.id,
      gramKey: request.gramKey,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function riskGetApprovalQueryFn(
      ctx,
    ): Promise<RiskGetApprovalQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(riskApprovalsGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRiskGetApproval(
  parameters: {
    id: string;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "approvals", "get", parameters];
}
